import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";

const apiClient = new APIClient();

export const getInterest = async () => {
    try {
        let currentInterestRate = localStorage.getItem("currentInterestRate");
        let currentInterestTea = localStorage.getItem("currentInterestTea");
        if ((currentInterestRate && currentInterestRate !== "null") && (currentInterestTea && currentInterestTea !== "null")) {
            return currentInterestRate;
        }
        let response = await apiClient.get(url.GET_RATES_CURRENT_INTEREST);
        let interest = response.data.data[0].tasa ?? null;
        let tea = response.data.data[0].tea ?? null;
        tea = parseFloat(tea);
        if (isNaN(tea) || !isFinite(tea)) tea = 0;
        localStorage.setItem("currentInterestRate", interest);
        if (tea > 0) localStorage.setItem("currentInterestTea", tea);
        return;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const getAndSetInterestTea = async () => {
    try {
        let currentInteresTea = localStorage.getItem("currentInterestTea");
        if (currentInteresTea && currentInteresTea !== "null") {
            return currentInteresTea;
        }
        let response = await apiClient.get(url.GET_RATES_CURRENT_INTEREST);
        let interestTea = response.data.data[0].tea ?? null;
        localStorage.setItem("currentInterestTea", interestTea);
        return;
    } catch (error) {
        console.log(error);
        return;
    }
};